import React from 'react';
import styled from 'styled-components';

const SocialmediaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* background: blue; */
  grid-column: 8 / span 3;
  @media (max-width: 650px){
    grid-column: 6/ 11;  
  }

`
const MediahandleBox = styled.div`
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
const Media = styled.div`
  display: inline-block;
  margin: 0 .2rem;
  @media (min-width: 768px){
    margin: .7rem;
  }
`
const BackToTop = styled.div`
  width: 6rem;
  height: 8rem;
  background:${props => props.theme.primaryColor};
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 1rem;
  border-radius: .2rem;
  cursor: pointer;
  margin: 1.5rem .7rem;

`
const Text = styled.p`
  font-size: 1.6rem;
  color: #fff;
  margin: .1rem 0;
`
const BackBox = styled.div`
  display: flex;
  justify-content: flex-end;
`

function Socialmedia() {
  return (
    <SocialmediaWrapper>
      <MediahandleBox>
        <Media>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" fill="#FB4B4B" />
            <path d="M31.6667 0H8.33333C3.73167 0 0 3.73167 0 8.33333V31.6667C0 36.2683 3.73167 40 8.33333 40H31.6667C36.27 40 40 36.2683 40 31.6667V8.33333C40 3.73167 36.27 0 31.6667 0ZM29.765 28.525C29.6567 28.67 29.57 29.2867 29.4267 29.7733C29.2633 30.335 28.7483 30.2717 28.1767 30.16C27.345 29.9983 26.6017 29.9517 25.7367 30.095C24.24 30.3433 22.6867 32.5567 20.0817 32.5567C17.2783 32.5567 15.82 30.355 14.265 30.095C12.68 29.8317 11.77 30.255 11.2217 30.255C10.8017 30.255 10.6383 29.9983 10.575 29.785C10.435 29.3067 10.345 28.6783 10.235 28.5283C9.15833 28.3617 6.73 27.9383 6.66667 26.8533C6.65167 26.5717 6.85 26.3233 7.12833 26.2767C10.6933 25.69 12.9633 21.6683 12.5933 20.7983C12.33 20.1783 11.1933 19.9567 10.715 19.7667C9.48167 19.2783 9.31 18.7167 9.38333 18.3333C9.485 17.8 10.135 17.4417 10.68 17.4417C11.2033 17.4417 12.1283 18.1417 12.8483 17.7433C12.74 15.8717 12.4767 13.1967 13.1433 11.7033C14.415 8.85333 17.2 7.445 19.985 7.445C22.79 7.445 25.595 8.875 26.8567 11.7017C27.5217 13.1933 27.26 15.8567 27.1533 17.7433C27.8333 18.1183 28.675 17.425 29.2617 17.425C29.8367 17.425 30.6183 17.8133 30.6317 18.4633C30.6417 18.9717 30.1883 19.41 29.2833 19.7667C28.7967 19.9583 27.6683 20.18 27.405 20.7983C27.0267 21.69 29.3667 25.7 32.87 26.2767C33.1483 26.3217 33.3483 26.57 33.3317 26.8533C33.2717 27.9367 30.8317 28.3583 29.765 28.525Z" fill="black" />
          </svg>
        </Media>
        <Media>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
              <rect width="40" height="40" fill="black" />
              <path d="M37.7917 0H2.20833C0.988333 0 0 0.988333 0 2.20833V37.7933C0 39.0117 0.988333 40 2.20833 40H21.3667V24.51H16.1533V18.4733H21.3667V14.0217C21.3667 8.855 24.5217 6.04167 29.1317 6.04167C31.34 6.04167 33.2367 6.20667 33.79 6.28V11.68L30.5933 11.6817C28.0867 11.6817 27.6017 12.8733 27.6017 14.62V18.475H33.58L32.8017 24.5117H27.6017V40H37.795C39.0117 40 40 39.0117 40 37.7917V2.20833C40 0.988333 39.0117 0 37.7917 0V0Z" fill="#FB4B4B" />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="40" height="40" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Media>
        <Media>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
              <path d="M20 3.605C25.34 3.605 25.9733 3.625 28.0833 3.72167C33.5033 3.96833 36.035 6.54 36.2817 11.92C36.3783 14.0283 36.3967 14.6617 36.3967 20.0017C36.3967 25.3433 36.3767 25.975 36.2817 28.0833C36.0333 33.4583 33.5083 36.035 28.0833 36.2817C25.9733 36.3783 25.3433 36.3983 20 36.3983C14.66 36.3983 14.0267 36.3783 11.9183 36.2817C6.485 36.0333 3.96667 33.45 3.72 28.0817C3.62333 25.9733 3.60333 25.3417 3.60333 20C3.60333 14.66 3.625 14.0283 3.72 11.9183C3.96833 6.54 6.49333 3.96667 11.9183 3.72C14.0283 3.625 14.66 3.605 20 3.605ZM20 0C14.5683 0 13.8883 0.0233333 11.755 0.12C4.49167 0.453333 0.455 4.48333 0.121667 11.7533C0.0233333 13.8883 0 14.5683 0 20C0 25.4317 0.0233333 26.1133 0.12 28.2467C0.453333 35.51 4.48333 39.5467 11.7533 39.88C13.8883 39.9767 14.5683 40 20 40C25.4317 40 26.1133 39.9767 28.2467 39.88C35.5033 39.5467 39.55 35.5167 39.8783 28.2467C39.9767 26.1133 40 25.4317 40 20C40 14.5683 39.9767 13.8883 39.88 11.755C39.5533 4.49833 35.5183 0.455 28.2483 0.121667C26.1133 0.0233333 25.4317 0 20 0V0ZM20 9.73C14.3283 9.73 9.73 14.3283 9.73 20C9.73 25.6717 14.3283 30.2717 20 30.2717C25.6717 30.2717 30.27 25.6733 30.27 20C30.27 14.3283 25.6717 9.73 20 9.73ZM20 26.6667C16.3183 26.6667 13.3333 23.6833 13.3333 20C13.3333 16.3183 16.3183 13.3333 20 13.3333C23.6817 13.3333 26.6667 16.3183 26.6667 20C26.6667 23.6833 23.6817 26.6667 20 26.6667ZM30.6767 6.925C29.35 6.925 28.275 8 28.275 9.325C28.275 10.65 29.35 11.725 30.6767 11.725C32.0017 11.725 33.075 10.65 33.075 9.325C33.075 8 32.0017 6.925 30.6767 6.925Z" fill="#FB4B4B" />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="40" height="40" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Media>
      </MediahandleBox>
      <BackBox>
        <BackToTop>
          <Text>Back</Text>
          <Text>To</Text>
          <Text>Top</Text>
        </BackToTop>
      </BackBox>

    </SocialmediaWrapper>
  )
}

export default Socialmedia
